export default {"src":"/_next/static/media/loader.f0448993.gif","height":291,"width":441,"blurWidth":0,"blurHeight":0};